import { Flex, Select } from "antd";
import "./styles.css";
import { DownOutlined } from "@ant-design/icons";

const filterOption = (input, option) =>
  (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

const placeholderWithSearchIcon = (placeholderText) => {
  return (
    <>
      <Flex justify="space-between" align="center">
        <p className="single-select-dropdown-placeholder-text">
          {placeholderText}
        </p>
        <DownOutlined className="dropdown-icon" />
      </Flex>
    </>
  );
};
export const SingleSelectDropdown = (props) => {
  const { options, placeholder, loading, onChange, value, onSearch } = props;
  return (
    <Select
      className="single-select-dropdown"
      showSearch
      loading={loading}
      placeholder={placeholderWithSearchIcon(placeholder)}
      optionFilterProp="children"
      onChange={onChange}
      filterOption={filterOption}
      options={options}
      onSearch={onSearch}
      value={{ label: placeholderWithSearchIcon(value ? value : placeholder) }}
    />
  );
};
